module.exports = __webpack_public_path__ + "img/Jessel Duque.852dcf64.jpg";